// import React from 'react';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import { Container } from 'react-bootstrap';
// import Navigation from './components/Navigation';
// import HomePage from './pages/HomePage';
// import VehiclesPage from './pages/VehiclesPage';
// import VehicleDetailPage from './pages/VehicleDetailPage';
// import SellVehiclePage from './pages/SellVehiclePage';
// import UserProfilePage from './pages/UserProfilePage';
// import OrdersPage from './pages/OrdersPage';
// import ReportsPage from './pages/ReportsPage';
// import LoginPage from './pages/LoginPage';
// import RegisterPage from './pages/RegisterPage';
// import Footer from './components/Footer';
// import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';


// function App() {
//   return (
//     <BrowserRouter>
//       <Navigation />
//       <main className="py-4">
//         <Container>
//           <Routes>
//             <Route path="/" element={<HomePage />} />
//             <Route path="/vehicles" element={<VehiclesPage />} />
//             <Route path="/vehicles/:id" element={<VehicleDetailPage />} />
//             <Route path="/sell" element={<SellVehiclePage />} />
//             <Route path="/profile" element={<UserProfilePage />} />
//             <Route path="/orders" element={<OrdersPage />} />
//             <Route path="/reports" element={<ReportsPage />} />
//             <Route path="/login" element={<LoginPage />} />
//             <Route path="/register" element={<RegisterPage />} />
//           </Routes>
//         </Container>
//       </main>
//       <Footer />
//     </BrowserRouter>
//   );
// }

// export default App;

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import HomePage from './pages/HomePage';
import VehiclesPage from './pages/VehiclesPage';
import VehicleDetailPage from './pages/VehicleDetailPage';
import SellVehiclePage from './pages/SellVehiclePage';
import UserProfilePage from './pages/UserProfilePage';
import OrdersPage from './pages/OrdersPage';
import ReportsPage from './pages/ReportsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <Router>
      <Navigation />
      <main className="py-4">
        <Container>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/vehicles" element={<VehiclesPage />} />
            <Route path="/vehicles/:id" element={<VehicleDetailPage />} />
            <Route path="/sell" element={<SellVehiclePage />} />
            <Route path="/profile" element={<UserProfilePage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
          </Routes>
        </Container>
      </main>
      <Footer />
    </Router>
  );
}

const Navigation = () => {
  return (
    <Navbar bg="dark" variant="dark" expand="lg" collapseOnSelect>
      <Container>
        <Navbar.Brand as={Link} to="/" className="fw-bold">
          <i className="fas fa-car me-2" />
          UKSecondhand
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/vehicles">Browse Vehicles</Nav.Link>
            <Nav.Link as={Link} to="/sell">Sell Your Vehicle</Nav.Link>
          </Nav>
          <Nav>
            <NavDropdown title={<><i className="fas fa-user me-1" /> Account</>} id="account-dropdown">
              <NavDropdown.Item as={Link} to="/profile">Profile</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/orders">My Orders</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/reports">Reports</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item>Logout</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={Link} to="/login">Login</Nav.Link>
            <Nav.Link as={Link} to="/register">Register</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default App;